module.exports = __webpack_public_path__ + "static/media/Logo__GCP.383e6f78.svg";